//------------------------------------------------------------------------------
// <auto-generated>
// This code was generated by d2-i18n-generate.
//
// Changes to this file may cause incorrect behavior and will be lost if
// the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
import i18n from '@dhis2/d2-i18n';
import arTranslations from './ar/translations.json';
import ar_IQTranslations from './ar_IQ/translations.json';
import bnTranslations from './bn/translations.json';
import ckbTranslations from './ckb/translations.json';
import csTranslations from './cs/translations.json';
import daTranslations from './da/translations.json';
import enTranslations from './en/translations.json';
import esTranslations from './es/translations.json';
import es_419Translations from './es_419/translations.json';
import frTranslations from './fr/translations.json';
import idTranslations from './id/translations.json';
import kmTranslations from './km/translations.json';
import loTranslations from './lo/translations.json';
import myTranslations from './my/translations.json';
import nbTranslations from './nb/translations.json';
import nlTranslations from './nl/translations.json';
import orTranslations from './or/translations.json';
import prsTranslations from './prs/translations.json';
import psTranslations from './ps/translations.json';
import ptTranslations from './pt/translations.json';
import pt_BRTranslations from './pt_BR/translations.json';
import roTranslations from './ro/translations.json';
import ruTranslations from './ru/translations.json';
import siTranslations from './si/translations.json';
import svTranslations from './sv/translations.json';
import tetTranslations from './tet/translations.json';
import tgTranslations from './tg/translations.json';
import ukTranslations from './uk/translations.json';
import urTranslations from './ur/translations.json';
import uz_LatnTranslations from './uz_Latn/translations.json';
import uz_UZ_CyrlTranslations from './uz_UZ_Cyrl/translations.json';
import uz_UZ_LatnTranslations from './uz_UZ_Latn/translations.json';
import viTranslations from './vi/translations.json';
import zhTranslations from './zh/translations.json';
import zh_CNTranslations from './zh_CN/translations.json';
const namespace = 'default';
i18n.addResources('ar', namespace, arTranslations);
i18n.addResources('ar_IQ', namespace, ar_IQTranslations);
i18n.addResources('bn', namespace, bnTranslations);
i18n.addResources('ckb', namespace, ckbTranslations);
i18n.addResources('cs', namespace, csTranslations);
i18n.addResources('da', namespace, daTranslations);
i18n.addResources('en', namespace, enTranslations);
i18n.addResources('es', namespace, esTranslations);
i18n.addResources('es_419', namespace, es_419Translations);
i18n.addResources('fr', namespace, frTranslations);
i18n.addResources('id', namespace, idTranslations);
i18n.addResources('km', namespace, kmTranslations);
i18n.addResources('lo', namespace, loTranslations);
i18n.addResources('my', namespace, myTranslations);
i18n.addResources('nb', namespace, nbTranslations);
i18n.addResources('nl', namespace, nlTranslations);
i18n.addResources('or', namespace, orTranslations);
i18n.addResources('prs', namespace, prsTranslations);
i18n.addResources('ps', namespace, psTranslations);
i18n.addResources('pt', namespace, ptTranslations);
i18n.addResources('pt_BR', namespace, pt_BRTranslations);
i18n.addResources('ro', namespace, roTranslations);
i18n.addResources('ru', namespace, ruTranslations);
i18n.addResources('si', namespace, siTranslations);
i18n.addResources('sv', namespace, svTranslations);
i18n.addResources('tet', namespace, tetTranslations);
i18n.addResources('tg', namespace, tgTranslations);
i18n.addResources('uk', namespace, ukTranslations);
i18n.addResources('ur', namespace, urTranslations);
i18n.addResources('uz_Latn', namespace, uz_LatnTranslations);
i18n.addResources('uz_UZ_Cyrl', namespace, uz_UZ_CyrlTranslations);
i18n.addResources('uz_UZ_Latn', namespace, uz_UZ_LatnTranslations);
i18n.addResources('vi', namespace, viTranslations);
i18n.addResources('zh', namespace, zhTranslations);
i18n.addResources('zh_CN', namespace, zh_CNTranslations);
export default i18n;